export type UpdatedPhotoCardPayload = { photoCardId: string; collectedCount: number };

export const sendPhotoCardUpdateMessage = (photoCards: UpdatedPhotoCardPayload[]): void => {
  window.opener?.postMessage(
    {
      type: 'update-collected-count-on-artist-photo-cards',
      params: { photoCards }
    },
    window.location.origin
  );
};
